import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { BehaviorSubject, Subject } from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';

export interface NewOrderRealtimeDto {
  orderCode: number;
  cliente: string;
  total: number;
}

export interface OrderStatusChangedRealtimeDto {
  orderCode: number;
  status: string;
}

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  private hubConnection!: signalR.HubConnection;

  private nuevaOrdenSubject = new Subject<any>();
  private cambioEstadoSubject = new Subject<any>();

  public nuevaOrden$ = this.nuevaOrdenSubject.asObservable();
  public cambioEstadoPedido$ = this.cambioEstadoSubject.asObservable();

  private mensajeSubject = new BehaviorSubject<string | null>(null);
  mensaje$ = this.mensajeSubject.asObservable();

  constructor(private authService: AuthService) {}

  connect(): void {
    if (this.hubConnection) return;

    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${environment.urlApiSignalR}`, {
        withCredentials: true,
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
        accessTokenFactory: () => localStorage.token || '',
      })
      .withAutomaticReconnect()
      .build();

    this.hubConnection
      .start()
      .then(() => console.log('🟢 SignalR conectado'))
      .catch((err) => console.error('🔴 SignalR error', err));

    this.listenNuevaOrden();
    this.listenCambioEstado();
  }

  private listenNuevaOrden(): void {
    this.hubConnection.on('newOrderCreated', (order: NewOrderRealtimeDto) => {
      this.nuevaOrdenSubject.next(order);
    });
  }

  private listenCambioEstado(): void {
    this.hubConnection.on(
      'orderStatusChanged',
      (event: OrderStatusChangedRealtimeDto) => {
        this.cambioEstadoSubject.next(event);
      },
    );
  }

  disconnect(): void {
    if (this.hubConnection) {
      this.hubConnection.stop();
    }
  }
}
